import React, { useContext } from "react";
import { ProductContext } from "../../../stores/session";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";

export default function StatusSelect({ data, updateStatus }) {
    const { statuses, uuidColumn } = useContext(ProductContext)

    return (
        <GenericDataRow title={'Status'} contentColour={'var(--white)'} contentStyle={{ padding: '0px' }} >
            <select 
                style={{ border: 'none', width: '100%', outline: 'none' }} 
                onChange={updateStatus} 
                value={data.status ?? "New"}
                disabled={!data[uuidColumn]}
            >
                {
                    statuses.map(status => {
                        return (
                            <option key={status} value={status}>
                                {status}
                            </option>
                        )
                    })
                }
            </select>
        </GenericDataRow>
    )
}